<script setup lang="ts">
import { useCounter, useTimeoutFn } from '@vueuse/core';
import { APP } from '../../configs/app';
import Modal from './Modal.vue';
import { ref, watch } from 'vue';
import { useSettingStore } from '../../stores/setting';
import { checkVersion } from '../../utils/utils';
import Heading from './Heading.vue';
import DebugData from './DebugData.vue';
import LoadingIcon from './LoadingIcon.vue';

const settingStore = useSettingStore()

const debugModalShow = ref<boolean>(false);
const updateModalShow = ref<boolean>(false);
const appVersionDisplay = APP.env === 'product' ? `v${APP.version}` : `v${APP.version}-${APP.env}`

const clickTimeout = 500
const clickRequited = 5
const { count, inc, reset } = useCounter(0);

const { start } = useTimeoutFn(() => reset(), clickTimeout, { immediate: false });

const handleClick = () => {
    inc()
    if (count.value < clickRequited) {
        // Restart timeout on each click
        start()
        return
    }

    debugModalShow.value = true
    reset()
}

const handleReloadUpdate = () => {
    // Append server version param to avoid cache
    const url = new URL(window.location.href);
    url.searchParams.set("v", settingStore.serverVersion || '');
    window.location.href = url.toString();
}

watch(() => settingStore.serverVersion, () => {
    if (!settingStore.serverVersion) return;

    const isOutDated = checkVersion(APP.version, settingStore.serverVersion) < 0 ? true : false

    if (isOutDated) {
        // show update modal
        debugModalShow.value = false
        updateModalShow.value = true
        setTimeout(() => {
            handleReloadUpdate()
        }, 2000)
        return
    }
}, { immediate: true })
</script>

<template>
    <!-- <Teleport to="body">
        <div class="text-neutral-400 fixed z-50 bottom-0 left-1 text-sm opacity-50 select-none" @click="handleClick">
            {{ appVersionDisplay }}
        </div>
    </Teleport> -->

    <span class="select-none" @click="handleClick">
        {{ appVersionDisplay }}
    </span>

    <Modal v-model="debugModalShow" size="medium" :full-height="true" :static="true">
        <DebugData />
    </Modal>

    <Modal v-model="updateModalShow" size="small" :static="true" :close-btn="false">
        <div class="flex flex-col w-full h-full overflow-hidden gap-3">
            <Heading alignment="center">A new version is available: {{ settingStore.serverVersion }}</Heading>
            <div class="text-center">
                Updating...
            </div>
            <LoadingIcon class="mx-auto" />
        </div>
    </Modal>
</template>